// @greenlight-spec: 26-versioning-update-strategy.md
/**
 * Whether a pre-rename stored value asked for prereleases. Two spellings were
 * persisted for one posture — the settings surface wrote `beta`, Helm and the
 * updater wrote `dev` — and both mean yes; anything else, including nothing,
 * means releases only. There is no third value: an install either takes
 * prereleases or it does not.
 *
 * Every reader that can meet a value stored before `include_prereleases`
 * existed goes through here, so the two spellings are enumerated once.
 */
export function includePrereleasesFromStoredValue(stored) {
    return stored === 'dev' || stored === 'beta';
}
//# sourceMappingURL=updates.js.map